import { Button } from '@octopus-do/octopus-storybook'

export const RegisterCommit = ({ errors, isLoading }) => {
  return (
    <>
      <div className="Register__commit">
        <Button
          type="submit"
          label="Sign up"
          loading={isLoading}
          disabled={Object.hasOwn(errors, 'recaptcha')}
        />
      </div>

      {Object.hasOwn(errors, 'recaptcha') && (
        <div className="Register__error">{errors.recaptcha}</div>
      )}
    </>
  )
}
